import { render, staticRenderFns } from "./headerDesignType.vue?vue&type=template&id=6c5bedce&scoped=true"
import script from "./headerDesignType.vue?vue&type=script&lang=js"
export * from "./headerDesignType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bedce",
  null
  
)

export default component.exports